import { Injectable } from '@angular/core';
import { CVApiService } from '../services/cv-api.service';
import { DateParadigmDTO } from '../models/date-paradigm.model';

@Injectable({
    providedIn: 'root'
})
export class DateParadigmFilterService {
    constructor(private cvApiService: CVApiService) { }

    async loadDateParadigmData(selectedMetrics: number[]) {
        try {
            const metrics = JSON.stringify(selectedMetrics);
            let encodedMetrics = encodeURIComponent(metrics);
            let url = `/api/v1/metric-selector/date-paradigm/${encodedMetrics}`;
            const response = await this.cvApiService.get<DateParadigmDTO[]>(url);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting date paradigm data");
            throw err;
        }
    }
}
